// Copyright: IQGeo Limited 2010-2019
import myw from './baseComponent';
import './form/formComponent';
import './form/label';
import './form/checkbox';
import './form/dropdown';
import './form/form';
import './form/input';
import './form/textarea';
import './form/unitInput';
import './form/button';
import './form/primaryButton';
import './treeView';
import './tabPanel';
import './buttonPullDown';
import './toolbar';

export default myw;
